export default {
    agreement_categories: "Rozilik toifalari",
    app_code: "Initiator dastur kodi",
    authentication_login: "Autentifikatsiya kirish",
    authentication_password: "Autentifikatsiya paroli",
    cod_no: "Kod NO",
    credentials_of_authorized_person: "Vakolatli shaxsning avtorizatsiyasi",
    director: "Direktor",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Messenjerda bemorga sharh yozish uchun havolani yuborishni tasdiqlaysizmi?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Chekni bemorning messenjeriga yuborishni tasdiqlaysizmi?",
    employee_login: "Xodimning login",
    employee_password: "Xodim paroli",
    fdoc_instruction: "Xizmat to'g'ri ishlashi uchun IP-manzilni FDoc menejeriga o'tkazing, unga ilgaklar/so'rovlar keladi: <code>{ipaddress}</code>. Qabul qilmoqchi bo'lgan voqealarni ham nomlang: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "Xodimlar bo'limida, xodimni tahrirlashda, FDoc yorlig'ida, FDoc tizimidagi xodimning login va paroli ko'rsatilishi kerak.",
    files: "Fayllar",
    files_being_uploaded: "Fayllar yuklanmoqda. Yuklash tugaguncha sahifani yopmang.",
    fill_questionary: "So'rovnomani to'ldiring",
    first_new: "Avval yangilari",
    first_old: "Avval eskilari",
    gallery: "Galereya",
    header_in_akt: "Ko'rsatilgan xizmatlar aktida Cap",
    multiple_signers_support: "Bir nechta imzo qo'yuvchilarni qo'llab-quvvatlash",
    options: "Variantlar",
    or_folder_with_dcm_files: "yoki DCM fayllari bo'lgan papka",
    select_folder: "Papka tanlang",
    send_receipt_to_messenger: "Chekni bemorning messenjeriga yuboring",
    sign_selected_via_vendor: "{vendor} orqali tanlanganlarni imzolang",
    table: "Jadval"
}
